import { defaultsDeep } from 'lodash';
import { DefaultDataPoint, ChartData, ChartDataset } from 'chart.js';

import { baseChartConfig, baseDatasetConfig } from './chart-base.config';
import { ChartConfigBuilder, ChartDatasetConfigBuilder } from './chart-config.model';
export const spreadingFactorChartConfig: ChartConfigBuilder<'line', DefaultDataPoint<'line'>> = (title?: string) => {
    return defaultsDeep({
        options: {
            scales: {
                y: {
                    suggestedMin:7,
                    suggestedMax:12,
                },
            },

        }
    }, baseChartConfig(title));
};

export const spreadingFactorDatasetConfig: ChartDatasetConfigBuilder = (datasets: ChartDataset[]) => {
    return defaultsDeep(
        <ChartData<'line', DefaultDataPoint<'line'>, unknown>> {
            datasets: datasets.map((dataset: ChartDataset) => ({
                ...dataset,
            })),
        },
        baseDatasetConfig(datasets),
    );
}